import { Component, Input } from '@angular/core';

type SisHintTone = 'info' | 'warning' | 'error';

@Component({
  selector: 'app-sis-hint',
  templateUrl: './sis-hint.component.html',
  styleUrls: ['./sis-hint.component.css'],
  standalone: false
})
export class SisHintComponent {
  @Input() tone: SisHintTone = 'info';
}
